export const JOURNEY_MODAL_FLAG = "journeyModalPending";
export const SOCIAL_SIGNUP_DETAILS = "socialSignupDetails";
export const ONBOARDING_CHECKLIST = "onboardingChecklist";
export const LEARNING_SUBJECT_STORAGE_KEY = "learningSubjectSelection";
